import { useEffect, useState } from 'react';
import { BordButton } from 'bord-design-system';
import BordOneToneIcon from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import BordSelectDropdown from 'components/NudosComponents/BordSelectDropdown/BordSelectDropdown';
import { IQuoteItemDetailsForQuoteManagement, IQuoteItemReason } from 'types/quoteEditor.types';
import { QuoteEditorService } from 'services/quote-editor.service';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import { bordColorTheme } from '../../../../../styles/styles.constants';
import { getCategoryName } from '../../../../../utils/namingConventionsManagement';
import { PRODUCT_CATEGORY } from '../../../../../types/category';
import './SuggestReasonModalContent.scss';

interface ISuggestReasonModalContent {
  device: IQuoteItemDetailsForQuoteManagement;
  onClose: () => void;
  onConfirm: (reasonId: number, reasonName: string) => void;
}

/**
 * Contenido del modal para seleccionar el motivo antes de sugerir herramientas.
 * Carga las razones disponibles desde el catálogo y habilita el botón "Continuar" al elegir una.
 */
const SuggestReasonModalContent = ({ device, onClose, onConfirm }: ISuggestReasonModalContent) => {
  const [selectedReason, setSelectedReason] = useState<IQuoteItemReason | null>(null);
  const [reasons, setReasons] = useState<IQuoteItemReason[]>([]);
  const displayName =
    device.productName || `esta herramienta (${getCategoryName(device.categoryName as unknown as PRODUCT_CATEGORY)})`;

  const handleConfirm = () => {
    if (!selectedReason) return;
    onConfirm(selectedReason.id, selectedReason.label);
  };

  useEffect(() => {
    QuoteEditorService.getQuoteItemReasons()
      .then(setReasons)
      .catch(() => displayErrorNotification());
  }, []);

  const reasonOptions = reasons.map(reason => (
    <div key={reason.id} className="optionContainer" onClick={() => setSelectedReason(reason)}>
      {reason.label}
    </div>
  ));

  return (
    <div className="suggestReasonModalContent">
      <button className="closeBtn" onClick={onClose}>
        <BordOneToneIcon variant="x" standardSize={18} />
      </button>
      <div className="iconContainer">
        <BordOneToneIcon variant="info" customWidth={'6.5rem'} stroke={bordColorTheme.navyBlue[900]} />
      </div>
      <div className="title">
        Sugiere herramientas para
        <span className="deviceName">{displayName}</span>
      </div>
      <div className="description">Para sugerir herramientas debes indicar el motivo</div>
      <BordSelectDropdown
        label="Selecciona un motivo"
        currentValueOrplaceholder={selectedReason?.label || 'Selecciona un motivo'}
        isFilled={!!selectedReason}
        selectOptions={reasonOptions}
        selectClassName="reasonSelect"
      />
      <BordButton
        label="Continuar"
        disabled={!selectedReason}
        onClick={handleConfirm}
        customClassName="continueBtn"
        customWidth="w-380"
      />
      <div className="cancelLink" onClick={onClose}>
        Cancelar
      </div>
    </div>
  );
};

export default SuggestReasonModalContent;
